import { Flex, xcss } from '@atlaskit/primitives';

import { RightHandSideProps } from '../../../common/types.js';
import { useGetSelectedCodingAgentAvatarsFromSearchParams } from '../../../controllers';
import { Injections, ProjectSvg } from '../../assets/project-svg.tsx';

import { getListIssueTypeDynamicView } from './utils.tsx';
import { WorkTypeArrow } from './work-type-arrow.tsx';

export const RightHandSidePageWorkTypes = ({
	projectName,
	issueTypesIcons,
}: RightHandSideProps) => {
	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams(4, 18);
	const DynamicWorkTypesSvg = getListIssueTypeDynamicView(issueTypesIcons ?? [], assignedAgents);
	const injections: Injections = {
		additionalObject: WorkTypeArrow,
		svgBody: DynamicWorkTypesSvg,
	};
	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="list" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});
